export default __webpack_public_path__ + "static/media/linkedin.583bbd40.svg";